// PT-PT overrides merged on top of blockly/msg/pt base locale.
// Keys here take precedence over the official Blockly PT translations.
export const ptMessages = {
  CONTROLS_IF_MSG_IF: 'se',
  CONTROLS_IF_MSG_THEN: 'então fazer',
  CONTROLS_IF_MSG_ELSE: 'senão',
  CONTROLS_IF_MSG_ELSEIF: 'senão se',
  CONTROLS_REPEAT_TITLE: 'repetir %1 vezes',
  CONTROLS_REPEAT_INPUT_DO: 'fazer',
  CONTROLS_WHILEUNTIL_OPERATOR_WHILE: 'enquanto',
  CONTROLS_WHILEUNTIL_OPERATOR_UNTIL: 'até',
  CONTROLS_FOR_TITLE: 'contar com %1 de %2 a %3 em incrementos de %4',
  CONTROLS_FOREACH_TITLE: 'para cada item %1 na lista %2',
  CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK: 'sair do ciclo',
  CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE: 'continuar com a próxima iteração',
  LOGIC_COMPARE_TOOLTIP_EQ: 'Devolver verdadeiro se ambas as entradas forem iguais.',
  LOGIC_OPERATION_AND: 'e',
  LOGIC_OPERATION_OR: 'ou',
  LOGIC_NEGATE_TITLE: 'não %1',
  LOGIC_BOOLEAN_TRUE: 'verdadeiro',
  LOGIC_BOOLEAN_FALSE: 'falso',
  LOGIC_NULL: 'nulo',
  LOGIC_TERNARY_CONDITION: 'teste',
  LOGIC_TERNARY_IF_TRUE: 'se verdadeiro',
  LOGIC_TERNARY_IF_FALSE: 'se falso',
  MATH_NUMBER_HELPURL: '',
  MATH_ARITHMETIC_HELPURL: '',
  MATH_IS_EVEN: 'é par',
  MATH_IS_ODD: 'é ímpar',
  MATH_IS_PRIME: 'é primo',
  MATH_IS_WHOLE: 'é inteiro',
  MATH_IS_POSITIVE: 'é positivo',
  MATH_IS_NEGATIVE: 'é negativo',
  MATH_IS_DIVISIBLE_BY: 'é divisível por',
  MATH_CHANGE_TITLE: 'somar %2 a %1',
  MATH_ROUND_OPERATOR_ROUND: 'arredondar',
  MATH_ROUND_OPERATOR_ROUNDUP: 'arredondar por excesso',
  MATH_ROUND_OPERATOR_ROUNDDOWN: 'arredondar por defeito',
  MATH_ONLIST_OPERATOR_SUM: 'soma da lista',
  MATH_ONLIST_OPERATOR_MIN: 'mínimo da lista',
  MATH_ONLIST_OPERATOR_MAX: 'máximo da lista',
  MATH_ONLIST_OPERATOR_AVERAGE: 'média da lista',
  MATH_ONLIST_OPERATOR_MEDIAN: 'mediana da lista',
  MATH_ONLIST_OPERATOR_MODE: 'moda da lista',
  MATH_ONLIST_OPERATOR_RANDOM: 'item aleatório da lista',
  MATH_ONLIST_OPERATOR_STD_DEV: 'desvio padrão da lista',
  MATH_MODULO_TITLE: 'resto de %1 ÷ %2',
  MATH_CONSTRAIN_TITLE: 'restringir %1 entre %2 e %3',
  MATH_RANDOM_INT_TITLE: 'inteiro aleatório entre %1 e %2',
  MATH_RANDOM_FLOAT_TITLE_RANDOM: 'fracção aleatória',
  TEXT_JOIN_TITLE_CREATEWITH: 'criar texto com',
  TEXT_APPEND_TITLE: 'a %1 acrescentar texto %2',
  VARIABLES_DEFAULT_NAME: 'item',
  VARIABLES_GET_CREATE_SET: 'Criar bloco "definir %1"',
  VARIABLES_SET_CREATE_GET: 'Criar bloco "obter %1"',
  PROCEDURES_DEFNORETURN_PROCEDURE: 'fazer algo',
  PROCEDURES_DEFNORETURN_TITLE: 'para',
  PROCEDURES_DEFRETURN_RETURN: 'devolver',
  PROCEDURES_BEFORE_PARAMS: 'com:',
  PROCEDURES_CALL_BEFORE_PARAMS: 'com:',
  MAP_SELECT_LABEL: 'Mapa:',
  MAP_CHANGE_CONFIRM: 'Mudar de mapa irá parar o programa. Continuar?',
  MAP_LOAD_ERROR: 'Erro ao carregar o mapa',
  MAP_NONE_FOUND: 'Atenção: nenhum mapa encontrado em public/maps/.',
  NEW_VARIABLE: 'Criar variável…',
  RENAME_VARIABLE: 'Renomear variável…',
  DELETE_VARIABLE: 'Eliminar a variável "%1"',
  PROGRAM_SAVE_EMPTY_CONFIRM: 'O espaço de trabalho está vazio. Guardar mesmo assim?',
  PROGRAM_LOAD_RUNNING_CONFIRM: 'Carregar um ficheiro irá parar o programa atual. Continuar?',
  PROGRAM_LOAD_CONFIRM: 'Carregar este ficheiro irá substituir o programa atual. Continuar?',
  PROGRAM_LOAD_ERROR: 'Ficheiro inválido ou corrompido.',
  PROGRAM_NEW_CONFIRM: 'Apagar programa atual? Isto não pode ser desfeito.',
  PROGRAM_UNSUPPORTED_BLOCKS: 'Aviso: Alguns blocos do ficheiro não são suportados e foram ignorados.',
};
